import styled from "styled-components";

export const MobileProfileGloryArenaStyled = styled.div`
`;

export const MobileProfileGloryArenaHeaderStyled = styled.div`
    margin-bottom: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: end;
    font-size: 16px;
    font-weight: 600;
    color: var(--color-label-secondary);

    .more {
        line-height: 1;
        cursor: pointer;

        svg {
            position: relative;
            top: -2px;
        }
    }
`;